import React from 'react';
import { X, Check } from 'lucide-react';
import { motion } from 'framer-motion';
const BEFORE = ['Hipervigilancia constante', 'Taquicardia sin razón aparente', 'Cansancio que no se va', 'Pensamientos catastróficos', 'Pecho apretado todo el día', 'Dormir sin descansar'];
const AFTER = ['Respiración profunda automática', 'Pecho relajado', 'Más estabilidad emocional', 'Mente que puede soltar', 'Sensación corporal de seguridad', 'Despertar descansada'];
export function BeforeAfterSection() {
  return <section className="py-20 bg-white px-4" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-gray-900 mb-4" data-id="element-3">
          La transformación es física, no mental
        </h2>
        <p className="text-center text-gray-500 mb-12 text-lg" data-id="element-4">
          No es que "pienses diferente". Es que tu cuerpo siente diferente.
        </p>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-5">
          {/* Before */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-gray-50 rounded-2xl p-8 border border-gray-200" data-id="element-6">
            <div className="flex items-center gap-3 mb-6" data-id="element-7">
              <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center" data-id="element-8">
                <X className="h-4 w-4 text-red-500" data-id="element-9" />
              </div>
              <h3 className="text-xl font-bold text-gray-700" data-id="element-10">Ahora</h3>
            </div>
            <ul className="space-y-3" data-id="element-11">
              {BEFORE.map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-600" data-id="element-12">
                  <X className="h-4 w-4 text-red-500 flex-shrink-0" data-id="element-13" />
                  <span data-id="element-14">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* After */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="bg-[#FAF5EF] rounded-2xl p-8 border border-[#C4973B]/30 shadow-md" data-id="element-15">
            <div className="flex items-center gap-3 mb-6" data-id="element-16">
              <div className="w-8 h-8 rounded-full bg-[#C4973B]/20 flex items-center justify-center" data-id="element-17">
                <Check className="h-4 w-4 text-[#C4973B]" data-id="element-18" />
              </div>
              <h3 className="text-xl font-bold text-[#9B4D4D]" data-id="element-19">
                Con Calma-5™
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-20">
              {AFTER.map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-800 font-semibold" data-id="element-21">
                  <Check className="h-4 w-4 text-[#C4973B] flex-shrink-0" data-id="element-22" />
                  <span data-id="element-23">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}